import { useTranslation } from 'react-i18next';

import { Stack, Typography } from '@mui/material';

import { EMemberStatus } from '@/config/member';

type TMemberStatusProps = {
  value: EMemberStatus;
  since: Date;
  sx?: string;
};

export const MemberStatus = ({ value, since, sx }: TMemberStatusProps) => {
  const { t } = useTranslation();

  const render = (color: string, labelKey: string, sinceKey: string) => (
    <Stack alignItems={sx ? 'center' : 'flex-start'} spacing={0.25}>
      <Typography
        variant="caption"
        color="white"
        sx={{
          paddingX: 1,
          paddingY: 0.25,
          borderRadius: '10px',
          backgroundColor: color,
        }}
        noWrap
      >
        {t(labelKey)}
      </Typography>

      <Typography variant="caption" color="text.disabled" noWrap>
        {t(sinceKey, { value: since })}
      </Typography>
    </Stack>
  );

  switch (value) {
    case EMemberStatus.INVITED:
      return render('info.main', 'members.statuses.invited', 'members.statuses.invitedOn');

    case EMemberStatus.ACTIVE:
      return render('success.dark', 'members.statuses.active', 'members.statuses.joinedOn');

    case EMemberStatus.SUSPENDED:
      return render(
        'custom.contrast.4',
        'members.statuses.suspended',
        'members.statuses.suspendedFrom',
      );
  }
};
